/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationVersionEntity } from './IntegrationVersionEntity';
import {
    IntegrationVersionEntityFromJSON,
    IntegrationVersionEntityFromJSONTyped,
    IntegrationVersionEntityToJSON,
    IntegrationVersionEntityToJSONTyped,
} from './IntegrationVersionEntity';
import type { IntegrationCatalogEntity } from './IntegrationCatalogEntity';
import {
    IntegrationCatalogEntityFromJSON,
    IntegrationCatalogEntityFromJSONTyped,
    IntegrationCatalogEntityToJSON,
    IntegrationCatalogEntityToJSONTyped,
} from './IntegrationCatalogEntity';

/**
 * 
 * @export
 * @interface IntegrationInstanceEntity
 */
export interface IntegrationInstanceEntity {
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {IntegrationCatalogEntity}
     * @memberof IntegrationInstanceEntity
     */
    integration?: IntegrationCatalogEntity;
    /**
     * 
     * @type {IntegrationVersionEntity}
     * @memberof IntegrationInstanceEntity
     */
    version?: IntegrationVersionEntity;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    instanceName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    instanceSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    webhookIngressToken?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IntegrationInstanceEntity
     */
    _configuration?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    outboundConfig?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IntegrationInstanceEntity
     */
    syncState?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    sourceSchema?: string;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationInstanceEntity
     */
    sourceSchemaLastFetched?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    sourceSchemaHash?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    status?: IntegrationInstanceEntityStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationInstanceEntity
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationInstanceEntity
     */
    rawDataCaptureEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    healthStatus?: IntegrationInstanceEntityHealthStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    healthMessage?: string;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationInstanceEntity
     */
    lastHealthCheck?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationInstanceEntity
     */
    lastExecutedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationInstanceEntity
     */
    lastExecutionTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    lastExecutionStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    lastError?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    consentStatus?: IntegrationInstanceEntityConsentStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationInstanceEntity
     */
    consentValidatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    consentError?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    scheduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    scheduleConfig?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    clonedFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    sourceTechnologyCode?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    ingestionFilterRuleId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    ingestionFilterRuleConfig?: string;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationInstanceEntity
     */
    installedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    installedBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationInstanceEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntegrationInstanceEntity
     */
    updatedBy?: string;
}


/**
 * @export
 */
export const IntegrationInstanceEntityStatusEnum = {
    Installed: 'INSTALLED',
    Enabled: 'ENABLED',
    Disabled: 'DISABLED',
    Error: 'ERROR'
} as const;
export type IntegrationInstanceEntityStatusEnum = typeof IntegrationInstanceEntityStatusEnum[keyof typeof IntegrationInstanceEntityStatusEnum];

/**
 * @export
 */
export const IntegrationInstanceEntityHealthStatusEnum = {
    Healthy: 'HEALTHY',
    Degraded: 'DEGRADED',
    Unhealthy: 'UNHEALTHY',
    Unknown: 'UNKNOWN'
} as const;
export type IntegrationInstanceEntityHealthStatusEnum = typeof IntegrationInstanceEntityHealthStatusEnum[keyof typeof IntegrationInstanceEntityHealthStatusEnum];

/**
 * @export
 */
export const IntegrationInstanceEntityConsentStatusEnum = {
    Granted: 'GRANTED',
    Revoked: 'REVOKED',
    Pending: 'PENDING',
    Unknown: 'UNKNOWN'
} as const;
export type IntegrationInstanceEntityConsentStatusEnum = typeof IntegrationInstanceEntityConsentStatusEnum[keyof typeof IntegrationInstanceEntityConsentStatusEnum];


/**
 * Check if a given object implements the IntegrationInstanceEntity interface.
 */
export function instanceOfIntegrationInstanceEntity(value: object): value is IntegrationInstanceEntity {
    return true;
}

export function IntegrationInstanceEntityFromJSON(json: any): IntegrationInstanceEntity {
    return IntegrationInstanceEntityFromJSONTyped(json, false);
}

export function IntegrationInstanceEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationInstanceEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'integration': json['integration'] == null ? undefined : IntegrationCatalogEntityFromJSON(json['integration']),
        'version': json['version'] == null ? undefined : IntegrationVersionEntityFromJSON(json['version']),
        'instanceName': json['instanceName'] == null ? undefined : json['instanceName'],
        'instanceSlug': json['instanceSlug'] == null ? undefined : json['instanceSlug'],
        'webhookIngressToken': json['webhookIngressToken'] == null ? undefined : json['webhookIngressToken'],
        '_configuration': json['configuration'] == null ? undefined : json['configuration'],
        'outboundConfig': json['outboundConfig'] == null ? undefined : json['outboundConfig'],
        'syncState': json['syncState'] == null ? undefined : json['syncState'],
        'sourceSchema': json['sourceSchema'] == null ? undefined : json['sourceSchema'],
        'sourceSchemaLastFetched': json['sourceSchemaLastFetched'] == null ? undefined : (new Date(json['sourceSchemaLastFetched'])),
        'sourceSchemaHash': json['sourceSchemaHash'] == null ? undefined : json['sourceSchemaHash'],
        'status': json['status'] == null ? undefined : json['status'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'rawDataCaptureEnabled': json['rawDataCaptureEnabled'] == null ? undefined : json['rawDataCaptureEnabled'],
        'healthStatus': json['healthStatus'] == null ? undefined : json['healthStatus'],
        'healthMessage': json['healthMessage'] == null ? undefined : json['healthMessage'],
        'lastHealthCheck': json['lastHealthCheck'] == null ? undefined : (new Date(json['lastHealthCheck'])),
        'lastExecutedAt': json['lastExecutedAt'] == null ? undefined : (new Date(json['lastExecutedAt'])),
        'lastExecutionTime': json['lastExecutionTime'] == null ? undefined : (new Date(json['lastExecutionTime'])),
        'lastExecutionStatus': json['lastExecutionStatus'] == null ? undefined : json['lastExecutionStatus'],
        'lastError': json['lastError'] == null ? undefined : json['lastError'],
        'consentStatus': json['consentStatus'] == null ? undefined : json['consentStatus'],
        'consentValidatedAt': json['consentValidatedAt'] == null ? undefined : (new Date(json['consentValidatedAt'])),
        'consentError': json['consentError'] == null ? undefined : json['consentError'],
        'scheduleId': json['scheduleId'] == null ? undefined : json['scheduleId'],
        'scheduleConfig': json['scheduleConfig'] == null ? undefined : json['scheduleConfig'],
        'clonedFrom': json['clonedFrom'] == null ? undefined : json['clonedFrom'],
        'sourceTechnologyCode': json['sourceTechnologyCode'] == null ? undefined : json['sourceTechnologyCode'],
        'ingestionFilterRuleId': json['ingestionFilterRuleId'] == null ? undefined : json['ingestionFilterRuleId'],
        'ingestionFilterRuleConfig': json['ingestionFilterRuleConfig'] == null ? undefined : json['ingestionFilterRuleConfig'],
        'installedAt': json['installedAt'] == null ? undefined : (new Date(json['installedAt'])),
        'installedBy': json['installedBy'] == null ? undefined : json['installedBy'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
    };
}

export function IntegrationInstanceEntityToJSON(json: any): IntegrationInstanceEntity {
    return IntegrationInstanceEntityToJSONTyped(json, false);
}

export function IntegrationInstanceEntityToJSONTyped(value?: IntegrationInstanceEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'integration': IntegrationCatalogEntityToJSON(value['integration']),
        'version': IntegrationVersionEntityToJSON(value['version']),
        'instanceName': value['instanceName'],
        'instanceSlug': value['instanceSlug'],
        'webhookIngressToken': value['webhookIngressToken'],
        'configuration': value['_configuration'],
        'outboundConfig': value['outboundConfig'],
        'syncState': value['syncState'],
        'sourceSchema': value['sourceSchema'],
        'sourceSchemaLastFetched': value['sourceSchemaLastFetched'] == null ? undefined : ((value['sourceSchemaLastFetched']).toISOString()),
        'sourceSchemaHash': value['sourceSchemaHash'],
        'status': value['status'],
        'enabled': value['enabled'],
        'rawDataCaptureEnabled': value['rawDataCaptureEnabled'],
        'healthStatus': value['healthStatus'],
        'healthMessage': value['healthMessage'],
        'lastHealthCheck': value['lastHealthCheck'] == null ? undefined : ((value['lastHealthCheck']).toISOString()),
        'lastExecutedAt': value['lastExecutedAt'] == null ? undefined : ((value['lastExecutedAt']).toISOString()),
        'lastExecutionTime': value['lastExecutionTime'] == null ? undefined : ((value['lastExecutionTime']).toISOString()),
        'lastExecutionStatus': value['lastExecutionStatus'],
        'lastError': value['lastError'],
        'consentStatus': value['consentStatus'],
        'consentValidatedAt': value['consentValidatedAt'] == null ? undefined : ((value['consentValidatedAt']).toISOString()),
        'consentError': value['consentError'],
        'scheduleId': value['scheduleId'],
        'scheduleConfig': value['scheduleConfig'],
        'clonedFrom': value['clonedFrom'],
        'sourceTechnologyCode': value['sourceTechnologyCode'],
        'ingestionFilterRuleId': value['ingestionFilterRuleId'],
        'ingestionFilterRuleConfig': value['ingestionFilterRuleConfig'],
        'installedAt': value['installedAt'] == null ? undefined : ((value['installedAt']).toISOString()),
        'installedBy': value['installedBy'],
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'updatedBy': value['updatedBy'],
    };
}

